export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FormErrorResult.vue?vue&type=template&id=01bf87a8&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/components/FormErrorResult.vue?vue&type=template&id=01bf87a8&
// module id = 1069
// module chunks = 0